(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["winter-special-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.wsp-countdown');
    if (!root) return;
    var end = new Date(root.getAttribute('data-end')).getTime();
    if (isNaN(end)) return;
    var d = root.querySelector('[data-d]');
    var h = root.querySelector('[data-h]');
    var m = root.querySelector('[data-m]');
    var s = root.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        d.textContent = h.textContent = m.textContent = s.textContent = '00';
        return;
      }
      var sec = Math.floor(diff / 1000);
      var days = Math.floor(sec / 86400);
      sec -= days * 86400;
      var hrs = Math.floor(sec / 3600);
      sec -= hrs * 3600;
      var min = Math.floor(sec / 60);
      sec -= min * 60;
      d.textContent = pad(days);
      h.textContent = pad(hrs);
      m.textContent = pad(min);
      s.textContent = pad(sec);
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
